"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_1 = __importDefault(require("@emotion/styled"));

var Button_1 = require("./Button");

var themes_1 = require("./themes");

var utils_1 = require("./utils");

var hasComponent = function hasComponent(children, displayNames) {
  var _a;

  var result = react_1.default.Children.map(children, function (child) {
    var _a, _b;

    if (displayNames.indexOf((_b = (_a = child) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.displayName) !== -1) {
      return true;
    }

    return false;
  });
  return (_a = result) === null || _a === void 0 ? void 0 : _a.some(function (x) {
    return x;
  });
};

var ImageContainer = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: ", "px;\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: ", "px;\n"])), function (_a) {
  var padding = _a.padding;
  return padding;
});
var ImageChildren = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  padding: 30px;\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  padding: 30px;\n"])));
var Image = styled_1.default.img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  object-fit: ", ";\n  border-top-left-radius: ", ";\n  border-top-right-radius: ", ";\n"], ["\n  width: 100%;\n  height: 100%;\n  object-fit: ", ";\n  border-top-left-radius: ", ";\n  border-top-right-radius: ", ";\n"])), function (_a) {
  var fit = _a.fit;
  return fit;
}, utils_1.getBorderRadius('card'), utils_1.getBorderRadius('card'));
var StyledCardImage = styled_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n\n  &::before {\n    content: '';\n    display: block;\n    padding-top: ", "%;\n  }\n"], ["\n  position: relative;\n  width: 100%;\n\n  &::before {\n    content: '';\n    display: block;\n    padding-top: ", "%;\n  }\n"])), function (_a) {
  var ratio = _a.ratio;
  return 100 / (ratio || 1);
});

exports.CardImage = function (_a) {
  var src = _a.src,
      ratio = _a.ratio,
      alt = _a.alt,
      children = _a.children,
      _b = _a.padding,
      padding = _b === void 0 ? 0 : _b,
      _c = _a.fit,
      fit = _c === void 0 ? 'contain' : _c,
      borderRadius = _a.borderRadius;
  return react_1.default.createElement(StyledCardImage, {
    ratio: ratio
  }, react_1.default.createElement(ImageContainer, {
    padding: padding
  }, react_1.default.createElement(Image, {
    src: src,
    alt: alt,
    fit: fit,
    borderRadius: borderRadius
  }), react_1.default.createElement(ImageChildren, null, children)));
};

exports.CardHeader = styled_1.default.header(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  padding-top: ", "px;\n  padding-right: ", "px;\n  padding-bottom: ", "px;\n  padding-left: ", "px;\n  display: flex;\n  flex-direction: column;\n"], ["\n  padding-top: ", "px;\n  padding-right: ", "px;\n  padding-bottom: ", "px;\n  padding-left: ", "px;\n  display: flex;\n  flex-direction: column;\n"])), function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.card) === null || _c === void 0 ? void 0 : _c.paddingTop, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.card.paddingTop;
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.card) === null || _c === void 0 ? void 0 : _c.paddingHorizontal, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.card.paddingHorizontal;
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.card) === null || _c === void 0 ? void 0 : _c.paddingInner, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.card.paddingInner;
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.card) === null || _c === void 0 ? void 0 : _c.paddingHorizontal, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.card.paddingHorizontal;
});
exports.CardHeader.displayName = 'CardHeader';
exports.CardTitle = styled_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-size: 1.5rem;\n  text-align: ", ";\n"], ["\n  font-size: 1.5rem;\n  text-align: ", ";\n"])), function (_a) {
  var align = _a.align;
  return align || 'unset';
});
exports.CardSubtitle = styled_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  font-size: 1.2rem;\n  text-align: ", ";\n"], ["\n  font-size: 1.2rem;\n  text-align: ", ";\n"])), function (_a) {
  var align = _a.align;
  return align || 'unset';
});
exports.CardBody = styled_1.default.article(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 auto;\n"], ["\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 auto;\n"])));
exports.CardBody.displayName = 'CardBody';
exports.CardActions = styled_1.default.footer(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  padding-top: ", "px;\n  padding-right: ", "px;\n  padding-bottom: ", "px;\n  padding-left: ", "px;\n  display: flex;\n  flex-direction: row;\n  justify-content: ", ";\n"], ["\n  padding-top: ", "px;\n  padding-right: ", "px;\n  padding-bottom: ", "px;\n  padding-left: ", "px;\n  display: flex;\n  flex-direction: row;\n  justify-content: ", ";\n"])), function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.card) === null || _c === void 0 ? void 0 : _c.paddingInner, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.card.paddingInner;
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.card) === null || _c === void 0 ? void 0 : _c.paddingHorizontal, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.card.paddingHorizontal;
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.card) === null || _c === void 0 ? void 0 : _c.paddingBottom, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.card.paddingBottom;
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.card) === null || _c === void 0 ? void 0 : _c.paddingHorizontal, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.card.paddingHorizontal;
}, function (_a) {
  var justify = _a.justify;
  return justify || 'flex-end';
});
exports.CardActions.displayName = 'CardActions';
exports.CardAction = styled_1.default(Button_1.Button)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  text-transform: uppercase;\n  font-weight: 500;\n  display: inline-block;\n  cursor: pointer;\n"], ["\n  text-transform: uppercase;\n  font-weight: 500;\n  display: inline-block;\n  cursor: pointer;\n"])));
exports.Card = styled_1.default.section(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  position: relative;\n  background: ", ";\n  color: ", ";\n  border-radius: ", ";\n  display: flex;\n  flex-direction: column;\n  flex: ", ";\n  box-shadow: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n  min-height: ", ";\n  margin: ", ";\n  cursor: ", ";\n\n  & > article {\n    padding-top: ", "px;\n    padding-right: ", "px;\n    padding-bottom: ", "px;\n    padding-left: ", "px;\n  }\n"], ["\n  position: relative;\n  background: ", ";\n  color: ", ";\n  border-radius: ", ";\n  display: flex;\n  flex-direction: column;\n  flex: ", ";\n  box-shadow: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n  min-height: ", ";\n  margin: ", ";\n  cursor: ", ";\n\n  & > article {\n    padding-top: ", "px;\n    padding-right: ", "px;\n    padding-bottom: ", "px;\n    padding-left: ", "px;\n  }\n"])), function (_a) {
  var backgroundColor = _a.backgroundColor,
      background = _a.background,
      theme = _a.theme;

  var _b, _c;

  return _c = (_b = backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : background, _b !== null && _b !== void 0 ? _b : theme.card.background), _c !== null && _c !== void 0 ? _c : '#fff';
}, function (_a) {
  var color = _a.color,
      theme = _a.theme;

  var _b;

  return _b = color !== null && color !== void 0 ? color : theme.card.color, _b !== null && _b !== void 0 ? _b : 'inherit';
}, utils_1.getBorderRadius('card'), function (_a) {
  var flex = _a.flex;
  return !flex ? '0 0 auto' : typeof flex === 'boolean' ? 1 : flex;
}, function (_a) {
  var theme = _a.theme;
  return theme.card.boxShadow;
}, function (_a) {
  var align = _a.align;
  return align || 'unset';
}, function (_a) {
  var justify = _a.justify;
  return justify || 'unset';
}, function (_a) {
  var minHeight = _a.minHeight;
  return minHeight || 'auto';
}, function (_a) {
  var margin = _a.margin,
      theme = _a.theme;
  return margin !== null && margin !== void 0 ? margin : "0 0 " + theme.card.marginBottom + "px";
}, function (_a) {
  var onClick = _a.onClick;
  return onClick ? 'pointer' : 'unset';
}, function (_a) {
  var theme = _a.theme,
      children = _a.children;

  var _b, _c, _d, _e, _f, _g;

  return hasComponent(children, ['CardHeader', 'Styled(header)']) ? (_d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.card) === null || _c === void 0 ? void 0 : _c.paddingInner, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.card.paddingInner) : (_g = (_f = (_e = theme) === null || _e === void 0 ? void 0 : _e.card) === null || _f === void 0 ? void 0 : _f.paddingTop, _g !== null && _g !== void 0 ? _g : themes_1.defaultTheme.card.paddingTop);
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.card) === null || _c === void 0 ? void 0 : _c.paddingHorizontal, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.card.paddingHorizontal;
}, function (_a) {
  var theme = _a.theme,
      children = _a.children;

  var _b, _c, _d, _e, _f, _g;

  return hasComponent(children, ['CardActions', 'Styled(footer)']) ? (_d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.card) === null || _c === void 0 ? void 0 : _c.paddingInner, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.card.paddingInner) : (_g = (_f = (_e = theme) === null || _e === void 0 ? void 0 : _e.card) === null || _f === void 0 ? void 0 : _f.paddingBottom, _g !== null && _g !== void 0 ? _g : themes_1.defaultTheme.card.paddingBottom);
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.card) === null || _c === void 0 ? void 0 : _c.paddingHorizontal, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.card.paddingHorizontal;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;